<app-form-select-new *rxLet="vm$; let vm"
                     [formControl]="ngControl.control"
                     [valueField]="'code'"
                     [data]="vm.items"
                     [loading]="vm.loading"
                     [showOutOfScopeValue]="showOutOfScopeValue"
                     (itemSelected)="itemSelected.emit($event)"
                     [label]="label"
                     [required]="required"></app-form-select-new>
